<div class="card-body">
    <div id="apex-stacked-columns"></div>
</div>